import { NavLink } from "react-router";
import styles from "./select-role.module.css";
import adminIcon from "illustrations/admin-frog.png";
import playerIcon from "illustrations/player-frog.png";

const SelectRole = ({ role }) => {
  let { name, title, description, url } = role;

  const isAdmin = name === "admin";

  return (
    <NavLink
      to={url}
      className={styles["select-role-card"]}
      data-testid={`select-role-card-${name}`}
    >
      <div className={styles["select-role-content"]}>
        <h3 className="title-3">{title}</h3>
        <p className="subtitle-1-variant">{description}</p>
      </div>
      <img
        src={isAdmin ? adminIcon : playerIcon}
        width="50"
        height="50"
        alt=""
      />
    </NavLink>
  );
};

export default SelectRole;
